import { discussionPosts, trendTags } from '@/mocks/gossipData';

const avatarTone = [
  'bg-primary-100 text-primary-700',
  'bg-accent-100 text-accent-700',
  'bg-secondary-200 text-secondary-800',
  'bg-primary-50 text-primary-600',
  'bg-accent-200 text-accent-800',
];

export default function DiscussionSection() {
  return (
    <section id="discuss" className="w-full scroll-mt-24 bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
              <div>
                <div className="flex items-center gap-2">
                  <span className="h-1.5 w-1.5 rounded-full bg-secondary-600" />
                  <span className="text-xs font-bold tracking-widest text-secondary-700 uppercase">理性讨论</span>
                </div>
                <h2 className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">吃瓜也要讲依据</h2>
                <p className="mt-1.5 text-sm text-foreground-600 md:text-[15px]">来自同好社区的讨论帖摘录，观点各异但都奔着同一件事：别让断章取义带偏节奏。</p>
              </div>
              <button
                type="button"
                className="group inline-flex cursor-pointer items-center gap-1.5 self-start whitespace-nowrap rounded-full border border-background-200 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 sm:self-auto"
              >
                <i className="ri-edit-2-line" /> 发个帖参与讨论
              </button>
            </div>

            <div className="mt-6 flex flex-col gap-3">
              {discussionPosts.map((d, idx) => (
                <article key={d.author} className="flex cursor-pointer gap-3 rounded-2xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-background-300 md:p-5">
                  <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-sm font-black ${avatarTone[idx % avatarTone.length]}`}>
                    {d.author.slice(0, 1)}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="text-sm font-bold text-foreground-900">{d.author}</span>
                      <span className="inline-flex items-center gap-1 rounded-full bg-secondary-50 px-2 py-0.5 text-[11px] font-medium text-secondary-700">
                        <i className="ri-award-line" /> {d.tag}
                      </span>
                      <span className="text-xs text-foreground-400">{d.time}</span>
                    </div>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-800">{d.text}</p>
                    <div className="mt-2.5 flex items-center gap-4 text-xs text-foreground-500">
                      <button type="button" className="inline-flex cursor-pointer items-center gap-1 rounded-full border border-background-200 px-2.5 py-1 transition-colors hover:border-primary-300 hover:text-primary-600">
                        <i className="ri-thumb-up-line" /> 认同 {d.agree}
                      </button>
                      <button type="button" className="inline-flex cursor-pointer items-center gap-1 transition-colors hover:text-foreground-700">
                        <i className="ri-message-3-line" /> {d.total}
                      </button>
                      <span className="ml-auto hidden sm:inline-flex items-center gap-1"><i className="ri-share-forward-line" /> 分享</span>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>

          <aside className="flex flex-col gap-4">
            <div className="rounded-2xl border border-background-200 bg-background-100/70 p-5 md:p-6">
              <div className="flex items-center gap-2 text-xs font-bold tracking-widest text-primary-600 uppercase">
                <i className="ri-fire-line" /> 实时热搜
              </div>
              <div className="mt-4 flex flex-wrap gap-2">
                {trendTags.map((t, i) => (
                  <a
                    key={t}
                    href="#feed"
                    className={`inline-flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-full border px-3 py-1.5 text-sm transition-colors hover:bg-background-50 ${
                      i < 3 ? 'border-accent-200 bg-accent-100 text-accent-900' : 'border-background-200 bg-background-50 text-foreground-700 hover:text-primary-700'
                    }`}
                  >
                    {i < 3 ? <i className="ri-fire-fill text-xs" /> : null}
                    {t}
                  </a>
                ))}
              </div>
            </div>

            <div id="subscribe" className="scroll-mt-24 overflow-hidden rounded-2xl bg-foreground-950 p-5 text-background-50 md:p-6">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-notification-3-line text-xl" />
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold leading-snug">订阅单个事件后续，反转不再错过</h3>
              <p className="mt-2 text-sm leading-relaxed text-background-200/80">
                订阅你关心的当事人回应与辟谣进度，有新增进展第一时间通知，理性吃瓜不用一直刷。
              </p>
              <button
                type="button"
                className="mt-5 flex w-full cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-lg bg-primary-500 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-400"
              >
                <i className="ri-add-line" /> 开始订阅
              </button>
              <div className="mt-3 flex items-center gap-1.5 text-[11px] text-background-300">
                <i className="ri-shield-check-line" /> 仅用于进展提醒，可随时取消
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}